<form [formGroup]="deductionForm" (ngSubmit)="onSubmit()">
  <div class="my-3">
    <p class="mb-0">Выберите работы:</p>
    <mat-error>{{ getMessageFormError('not_uploaded_works') }}</mat-error>
    <mat-selection-list class="d-flex flex-wrap">
      <mat-list-option
        *ngFor="let work of dialogData.list"
        class="w-auto"
        color="primary"
        (selectedChange)="toggleCheckWork(work.id)">
        #{{ work.number }}
      </mat-list-option>
    </mat-selection-list>
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Причина по которой студент не сдал работы: </mat-label>

    <textarea matInput formControlName="text"></textarea>
    <mat-error *ngIf="text!.errors?.required">{{
      requiredErrorMessage
    }}</mat-error>
    <mat-error>{{ getMessageFormError('text') }}</mat-error>
  </mat-form-field>

  <div mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      typeBtn="submit"
      label="Сохранить"
      [isDisabled]="isButtonDisabled()"
      [loading$]="loadingSubmit | async"></app-button-with-progress>
  </div>
</form>
